import { THEME } from 'components/theme'
export default {
  titleBar: {
    padding: '14px 10px 14px 16px',
    borderLeft: `1px solid ${THEME.brandLightGreen}`,
    borderBottom: `2px solid ${THEME.brandLightGrey}`,
    boxShadow: 'none'
  },
  ledgerRow: {
    transition: 'background-color 120ms ease',
    '&:nth-child(even)': {
      backgroundColor: THEME.brandWhite
    },
    '&:hover': {
      backgroundColor: THEME.lightGrey
    }
  },
  // Table scroll area with a wider, always-visible scrollbar (the default overlay
  // scrollbar is too thin to grab on a long report).
  scrollArea: {
    flex: 1,
    overflowY: 'scroll',
    overflowX: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#b6c0c3 transparent',
    '&::-webkit-scrollbar': {
      width: 14,
      height: 14
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#b6c0c3',
      borderRadius: 8,
      border: `3px solid ${THEME.brandWhite}`,
      backgroundClip: 'content-box'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#98a4a7',
      backgroundClip: 'content-box'
    }
  },
  // Jump-to-top control, shown once the list is scrolled.
  toTop: {
    position: 'absolute',
    right: 24,
    bottom: 24,
    width: 44,
    height: 44,
    borderRadius: '50%',
    border: 'none',
    background: THEME.brandGreen,
    color: THEME.onBrand,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 6px 16px rgba(28, 135, 59, 0.4)',
    zIndex: 20,
    transition: 'background 0.15s ease, transform 0.15s ease',
    '&:hover': {
      background: THEME.brandTintGreen,
      transform: 'translateY(-1px)'
    }
  },
  actionItem: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0px 36px',
    cursor: 'pointer',
    border: 0,
    backgroundColor: THEME.brandWhite
  },
  actionItemLoader: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 144
  },
  summaryContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 2,
    border: `1px solid ${THEME.brandLightGrey}`,
    borderRadius: 8
  },
  summaryBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexGrow: 1,
    padding: 16,
    fontSize: 14,
    lineHeight: 1.36,
    letterSpacing: '0.2px',
    color: THEME.brandBlack,
    boxShadow: `0 1px 0 0 ${THEME.brandLightGrey}`
  },
  summaryContent: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 4
  },
  payment: {
    backgroundColor: THEME.brandLightGreen,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    '& $customerAmount': {
      color: THEME.brandDarkGreen,
      fontWeight: 600
    },
    '& $supplierAmount': {
      color: THEME.brandDarkRed,
      fontWeight: 600
    }
  },
  credit: {
    backgroundColor: THEME.brandLighterGrey,
    '& $customerAmount': {
      color: THEME.brandDarkRed,
      fontWeight: 600
    },
    '& $supplierAmount': {
      color: THEME.brandDarkGreen,
      fontWeight: 600
    }
  },
  due: {
    backgroundColor: THEME.brandMedLightGrey,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    '& $amount': {
      color: THEME.brandDarkRed,
      fontWeight: 600
    }
  },
  customerAmount: {},
  supplierAmount: {},
  amount: {},
  tableHeadCell: {
    fontSize: '12px',
    lineHeight: 1.42,
    letterSpacing: 0.12,
    padding: '8px 10px 8px 16px',
    color: THEME.brandBlack
  },
  tableCell: {
    padding: '12px 10px 12px 16px',
    fontSize: 13,
    lineHeight: 1.38,
    letterSpacing: 0.18
  },
  dateCell: {
    color: THEME.brandDarkerGrey
  },
  notesCell: {
    color: THEME.brandBlack
  },
  smallTableCell: {
    width: 150
  },
  paymentText: {
    fontSize: 14,
    fontWeight: 600,
    color: THEME.brandDarkGreen,
    marginLeft: 8
  },
  creditText: {
    ontSize: 14,
    fontWeight: 600,
    color: THEME.brandDarkRed,
    marginLeft: 8
  },
  paymentType: {
    fontSize: '12px',
    lineHeight: 1.42,
    letterSpacing: '0.17px',
    marginTop: 4,
    marginLeft: 8,
    color: THEME.brandDarkerGrey
  },
  noTransactionCell: {
    padding: 16,
    fontSize: 14,
    color: THEME.brandDarkerGrey
  }
}
